export class AuthModule {
    constructor(httpModule) {
        this.httpModule = httpModule;
    }
    async login(credentials) {
        const loginRes = await this.httpModule.fetch("/login", {
            method: "POST",
            body: JSON.stringify(credentials),
        });
        const loginBody = (await loginRes.json());
        this.httpModule.setAuthToken(loginBody.accessToken);
        return loginBody;
    }
    signOut() {
        this.httpModule.setAuthToken("");
    }
    async register(newUser) {
        await this.httpModule.fetch("/register", {
            method: "POST",
            body: JSON.stringify(newUser),
        });
    }
    setJwt(token) {
        this.httpModule.setAuthToken(token);
    }
    getJwt() {
        return this.httpModule.getAuthToken();
    }
}
//# sourceMappingURL=Auth.module.js.map